import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { RiEditLine, RiMore2Fill } from "react-icons/ri";
import EdSelect from "@/components/forms/EdSelect";
import EdTextfield from "@/components/forms/EdTextfield";
import { useForm } from "react-hook-form";

interface Question {
  id: number;
  type: string;
  question: string;
  points: string;
}

interface QuestionsRecapModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const mockQuestions: Question[] = [
  {
    id: 1,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 2,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 3,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 4,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 5,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 6,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 7,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  },
  {
    id: 8,
    type: "Dom. a risposta multipla",
    question: "CHE COS'E' IL PERICOLO?",
    points: "3,6 punti"
  }
];

const questionTypes = [
  { value: "risposta-aperta", label: "Risposta aperta" },
  { value: "risposta-multipla", label: "Risposta multipla" },
  { value: "vero-falso", label: "Vero/Falso" },
  { value: "scelta-multipla", label: "Scelta multipla" }
];

export default function QuestionsRecapModal({ open, onClose, title }: QuestionsRecapModalProps) {
  const [questions] = useState<Question[]>(mockQuestions);
  const [showAddForm, setShowAddForm] = useState(false);
  
  const { register, watch, reset } = useForm({
    defaultValues: {
      tipologia: "risposta-aperta",
      punteggio: "3",
      domanda: "",
      risposta: "",
      descrizione: ""
    }
  });

  const watchFields = watch();

  const handleAddNewQuestion = () => {
    setShowAddForm(true);
  };

  const handleEditQuestion = (questionId: number) => {
    console.log("Modifica domanda:", questionId);
  };

  const handleAddQuestion = () => {
    console.log("Aggiungi domanda:", watchFields);
    setShowAddForm(false);
    reset();
  };


  const handleMoreOptions = (questionId: number) => {
    console.log("Opzioni aggiuntive per domanda:", questionId);
  };

  const handleSave = () => {
    console.log("Salva modifiche");
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '3px',
          padding: '20px',
          boxSizing: 'border-box',
          boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
      }}
    >
      <div className="px-6 pt-8 box-border">
        <span className="text-2xl font-medium text-gray-900"> {title}</span>
      </div>

      <DialogContent sx={{ padding: '0 24px' }}>
        <div className="py-4">
          {/* Questions List */}
          <div className="space-y-0">
            {questions.map((question) => (
              <div key={question.id}>
                <div className="flex items-center justify-between py-2.5">
            
                    <div className="text-sm text-gray-600">
                      {question.type}
                    </div>
         
                    <div className="text-sm font-medium text-gray-900">
                      {question.question}
                    </div>
                    <span className="text-sm text-black">
                      {question.points}
                    </span>
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                      <span
                        onClick={() => handleEditQuestion(question.id)}
                        className="p-1 cursor-pointer hover:bg-gray-100 rounded transition-colors shadow-none hover:shadown-none border-none active:border-none focus:border-none active:shadow-none focus:border-none"
                      >
                        <RiEditLine className="w-4 h-4 text-gray-600" />
                      </span>
                      <span
                        onClick={() => handleMoreOptions(question.id)}
                        className="p-1 cursor-pointer hover:bg-gray-100 rounded transition-colors"
                      >
                        <RiMore2Fill className="w-4 h-4 text-gray-600" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="border-b border-gray-200"></div>
              </div>
            ))}
          </div>

          {/* Add Question Form - Shows when no questions or when "Aggiungi domanda" is clicked */}
          {(questions.length === 0 || showAddForm) && (
            <div className="mt-6 ">
              <div className="space-y-4">
                {/* First Row - 3 inputs */}
                <div className="grid grid-cols-3 gap-4">
                  {/* Tipologia domanda */}
                  <div>
                    <EdSelect
                      label="Tipologia domanda"
                      id="tipologia"
                      value={watchFields.tipologia}
                      register={register("tipologia")}
                      options={questionTypes}
                      placeholder="Seleziona tipologia"
                    />
                  </div>

                  {/* Punteggio */}
                  <div>
                  <EdTextfield
                      label="Domanda"
                      type="text"
                      id="domanda"
                      placeholder="Domanda"
                      register={register("domanda")}
                    />
                  
                  </div>

                  {/* Domanda */}
                  <div>
                  <EdTextfield
                      label="Descrizione"
                      type="text"
                      id="descrizione"
                      placeholder="Descrizione"
                      register={register("descrizione")}
                    />
                  </div>
                </div>

                {/* Second Row - 2 inputs */}
                <div className="grid grid-cols-3 gap-4">
                  {/* Risposta */}
                  <div>
                  <EdTextfield
                      label="Punteggio"
                      type="number"
                      id="punteggio"
                      placeholder="Inserisci punteggio"
                      register={register("punteggio")}
                    />
                   
                  </div>

                  {/* Descrizione */}
                  <div>
                  <EdTextfield
                      label="Risposta *"
                      type="text"
                      id="risposta"
                      placeholder="Risposta"
                      register={register("risposta")}
                    />
                  </div>
                  <div></div>
                </div>

                {/* AGGIUNGI Button */}
                <div className="pt-2">
                  <Button
                    onClick={handleAddQuestion}
                    variant="contained"
                    sx={{
                      backgroundColor: '#B80F15',
                      color: 'white',
                      borderRadius: '4px',
                      textTransform: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      padding: '8px 24px',
                      '&:hover': {
                        backgroundColor: '#A00D12',
                      },
                      '&:focus': {
                        outline: 'none',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    AGGIUNGI
                  </Button>
                </div>
              </div>
            </div>
          )}

          {/* Add New Question Button - Only show if there are questions and form is not visible */}
          {questions.length > 0 && !showAddForm && (
            <div className="mt-4">
              <span
                onClick={handleAddNewQuestion}
                className="text-[#B80F15] text-sm font-medium cursor-pointer"
              >
                + Aggiungi nuova domanda
              </span>
            </div>
          )}
        </div>
      </DialogContent>

      <DialogActions sx={{ padding: '16px 24px 24px 24px', gap: '12px' }}>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            backgroundColor: '#B80F15',
            color: 'white',
            borderRadius: '4px',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            padding: '8px 24px',
            '&:hover': {
              backgroundColor: '#A00D12',
            },
            '&:focus': {
              outline: 'none',
              boxShadow: 'none',
            },
          }}
        >
          SALVA
        </Button>
        <Button
          onClick={handleCancel}
          variant="outlined"
          sx={{
            color: '#285192',
            backgroundColor: '#E3EBF7',
            border: 'none',
            borderRadius: '4px',
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            padding: '8px 24px',
            '&:hover': {
              backgroundColor: '#E3EBF7',
            },
            '&:focus': {
              outline: 'none',
              boxShadow: 'none',
            },
          }}
        >
          ANNULLA
        </Button>
      </DialogActions>
    </Dialog>
  );
}